"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var flattenDeep = function (array) {
    var result = [];
    var nodes = array.slice();
    var node;
    if (!array.length) {
        return result;
    }
    node = nodes.pop();
    do {
        if (node instanceof Array) {
            nodes.push.apply(nodes, node);
        }
        else {
            result.push(node);
        }
        // tslint:disable-next-line: no-conditional-assignment
    } while (nodes.length && (node = nodes.pop()) !== undefined);
    result.reverse();
    return result;
};
exports.default = flattenDeep;
//# sourceMappingURL=flattenDeep.js.map